import { status } from './plusMinusQuantity';
import interactionBlocker from './interactionBlocker';
import { getSectionsToRenderByUpdate, getSectionsToRenderByPDP } from './cartSections';

const updateCartView = (cart, customEvent, in_background) => {
  if (status.debouncing) {
    return;
  }

  if (!in_background) {
    document.dispatchEvent(new CustomEvent('cartWillUpdate', { detail: cart }));
  }

  // Update cart-header, cart-shipping, cart-totals, cart-icon-bubble, and cart-items
  let getSectionsToRender;
  if (window.location.pathname !== '/cart') {
    getSectionsToRender = getSectionsToRenderByPDP();
  } else {
    getSectionsToRender = getSectionsToRenderByUpdate();
  }

  getSectionsToRender.forEach((section) => {
    if (section.reused) {
      // If the section is reused or employed in multiple places across the site
      // we need to replace all elements with the same ID. For example, cart-indicator
      const elementsToReplace = document.querySelectorAll(`#${section.id}`);

      return elementsToReplace.forEach((element) => {
        const subElement = element.querySelector(section.selector); // we might want to replace a sub-element
        if (subElement) {
          subElement.innerHTML = getSectionInnerHTML(cart.sections[section.section], section.selector);
          return;
        }

        element.innerHTML = getSectionInnerHTML(cart.sections[section.section], section.selector);
      });
    }
    const elementToReplace =
      document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
    if (!cart.sections) {
      return;
    }

    elementToReplace.innerHTML = getSectionInnerHTML(cart.sections[section.section], section.selector);
  });

  // Dispatch a custom event baned "cartItemAdded" when an item was added to the cart
  if (customEvent && customEvent.name === 'addItem') {
    document.dispatchEvent(new CustomEvent('cartItemAdded', { detail: customEvent.detail }));
  }

  // Optimizely Test
  const dataCartEmpty = document.querySelector('[data-cart-empty]');
  if (dataCartEmpty) {
    if (window.location.pathname === '/cart') {
      if (cart.item_count === 0) {
        dataCartEmpty.style.display = 'block';
      } else {
        dataCartEmpty.style.display = 'none';
      }
    }
  }

  // Update Quadpay Widget - ZipPay 3rd party integration
  const quadpayCartElement = document.querySelector('[data-quadpay-cart]');

  if (window.location.pathname === '/cart' && quadpayCartElement) {
    const givexItem = cart.items.some((item) => item.product_type.indexOf('GIVEX') !== -1); // check if cart has GIVEX item
    const cartTotalPrice = cart.total_price / 100; // fix money format

    // update Quadpay widget value on cart update and include $4 MFPP.;
    if (cartTotalPrice >= 35 && cartTotalPrice <= 1600 && !givexItem) {
      quadpayCartElement.style.display = 'block';
      document.querySelector('quadpay-widget-v3')?.setAttribute('amount', cartTotalPrice + 4);
    } else {
      quadpayCartElement.style.display = 'none';
    }
  }

  // It's currently employed for specific event in the cart such as update any quantity, edit any item and remove any item
  // because under these scenario the cart object bring the entire data. It means, it contains all the items in the cart.
  // However, add an item to the cart won't bring the entire data. It means, all items won't come in the cart response.
  // So, we'll employ customEvent argument as flag, it will help to know when a add item to the cart invoked this function.
  if (!customEvent) {
    window.cart = cart;
  }

  // $(document).trigger('cartDidUpdate', cart);
  document.dispatchEvent(new CustomEvent('cartDidUpdate', { detail: cart }));

  // Interaction blocker: unblock cart
  interactionBlocker();
};

function getSectionInnerHTML(html, selector) {
  return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
}

export default function (cart, customEvent = null, in_background = false) {
  return cart && updateCartView(cart, customEvent, in_background);
}
